export default __webpack_public_path__ + "static/media/red-select.617c6ffc.png";